import { Page, type DispatchedAction } from '@eo/shared';

import { useAppSelector } from '../../app/store';
import { CapacityChrome } from './CapacityChrome';
import { CapacityContent } from './CapacityContent';
import { capacityController } from './controller';
import type { CapacityState } from './types';

// The backend scopes every report to a portfolio the caller may read; isAdmin
// here only decides whether the portfolio picker and team-wide panels are drawn.
export default function CapacityPage() {
  const isAdmin = useAppSelector((s) => s.staff.me?.isAdmin ?? false);
  const meId = useAppSelector((s) => s.staff.me?.id ?? null);

  return (
    <Page<CapacityState>
      controller={capacityController as never}
      header={({ data }) => <CapacityChrome data={data} isAdmin={isAdmin} />}
    >
      {({ data, actions, pageState }) => (
        <CapacityContent
          data={data}
          busy={pageState.fetching}
          isAdmin={isAdmin}
          meId={meId}
          onSync={(payload) => actions.syncMonth(payload) as Promise<DispatchedAction>}
          onQueryOptions={(payload) => void actions.queryOptions(payload)}
        />
      )}
    </Page>
  );
}
